export const API_SERVICE = {
	API: '/api/v1',
	API_CMS: '/api/v1/cms'
} as const;

export type TApiService = (typeof API_SERVICE)[keyof typeof API_SERVICE];
